import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'
import { ReactComponent as Icon } from "../svgs/A4_Powergrid.svg"

const A4Powergrid: React.VFC<SvgIconProps> = props => <SvgIcon viewBox={'0 0 76 76'} component={Icon} {...props} fill="currentColor" />
export default A4Powergrid
